import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/ContactForm.css';

interface TextareaFieldProps {
  id: string;
  name: string;
  label: string;
  value: string;
  error?: string;
  required?: boolean;
  placeholder?: string;
  rows?: number;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const TextareaField: React.FC<TextareaFieldProps> = ({
  id,
  name,
  label,
  value,
  error,
  required = false,
  placeholder,
  rows = 5,
  onChange
}) => {
  const { t } = useTranslation();
  const requiredLabel = t('accessibility.required');

  return (
    <div className="form-group">
      <label htmlFor={id}>
        {label} {required && <span aria-label={requiredLabel}>*</span>}
      </label>
      <textarea
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        rows={rows}
        required={required}
        placeholder={placeholder}
        aria-describedby={error ? `${id}-error` : undefined}
        aria-invalid={!!error}
      />
      {error && (
        <div id={`${id}-error`} className="form-error" role="alert">
          {error}
        </div>
      )}
    </div>
  );
};

export default TextareaField;

